import _noop from "lodash/noop";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import React, { PureComponent } from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import { cssClasses, strings } from '@douyinfe/semi-foundation/lib/es/timeline/constants';
import '@douyinfe/semi-foundation/lib/es/timeline/timeline.css';
const prefixCls = cssClasses.ITEM;
export default class Item extends PureComponent {
  render() {
    var _context;

    const {
      className,
      color,
      children,
      dot,
      type,
      style,
      time,
      extra,
      onClick
    } = this.props;
    const itemCls = cls(prefixCls, className);
    const dotCls = cls({
      ["".concat(prefixCls, "-head")]: true,
      ["".concat(prefixCls, "-head-custom")]: dot,
      [_concatInstanceProperty(_context = "".concat(prefixCls, "-head-")).call(_context, type)]: type
    });
    const dotStyle = color ? {
      style: {
        backgroundColor: color
      }
    } : null;
    return /*#__PURE__*/React.createElement("li", {
      className: itemCls,
      style: style,
      onClick: onClick
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-tail"),
      "aria-hidden": true
    }), /*#__PURE__*/React.createElement("div", _Object$assign({
      className: dotCls,
      "aria-hidden": true
    }, dotStyle), dot), /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, children, extra && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-content-extra")
    }, extra), time && /*#__PURE__*/React.createElement("div", {
      className: "".concat(prefixCls, "-content-time")
    }, time)));
  }

}
Item.propTypes = {
  color: PropTypes.string,
  time: PropTypes.node,
  type: PropTypes.oneOf(strings.ITEM_TYPE),
  dot: PropTypes.node,
  extra: PropTypes.node,
  position: PropTypes.oneOf(strings.ITEM_POS),
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
};
Item.defaultProps = {
  type: 'default',
  time: '',
  onClick: _noop
};